import React, { useState } from 'react';
// import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import ModalWrapper from '../ModalWrapper';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { converWalletCoin } from '../../redux/wallet/walletAction';

// const currencies = ['USD', 'EUR', 'CAD', 'NGN', 'GBP', 'JPY'];

export default function ConvertModal({ withdrawableBalance, coinBalance, onClose, onComplete, conversionRate }) {
    const queryClient = useQueryClient()
    const [loading, setLoading] = useState(false)
    const [coinAmount, setCoinAmount] = useState('');
    // const [currency, setCurrency] = useState('USD');
    // const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);

    // Conversion rate: 300 BD Coins = 1 USD
    // const conversionRate = 300;
    const usdValue = (parseFloat(coinAmount) || 0) * conversionRate;
    const insufficientBalance = parseFloat(coinAmount) > withdrawableBalance;

    const handleMaxClick = () => {
        setCoinAmount(withdrawableBalance?.toString());
    };

    const handleConverCoin = async () => {
        try {
            setLoading(true)
            await converWalletCoin(Number(coinAmount))
            queryClient.invalidateQueries({ queryKey: ["wallet", "details"]})
            onComplete?.()
        } catch (error) {
            toast.error(error.message || "Something went wrong")
        } finally {
            setLoading(false)
        }
    }

    return (
        <ModalWrapper onClose={!loading ? onClose : () => {}} title="Convert">
            <div className="p-4">
                <div className="flex items-center gap-4 mb-4">
                    {/* From (BD Coins) */}
                    <div className="flex-1">
                        <p className="text-gray-400 text-sm mb-2">From</p>
                        <div className="bg-[#4a4a4a] rounded-lg p-3 flex items-center gap-2">
                            <span className="text-[#c9a227]">●</span>
                            <input
                                type="text"
                                value={coinAmount}
                                placeholder='0.00'
                                onChange={(e) => setCoinAmount(e.target.value.replace(/[^0-9.]/g, ''))}
                                className="flex-1 bg-transparent text-white focus:outline-none"
                            />
                            <button
                                onClick={handleMaxClick}
                                className="text-[#c9a227] text-sm hover:underline"
                            >
                                Max
                            </button>
                        </div>
                    </div>

                    <ArrowRight className="w-6 h-6 text-gray-400 mt-6" />

                    {/* To (Currency) */}
                    <div className="flex-1">
                        <p className="text-gray-400 text-sm mb-2">To</p>
                        <div className="bg-[#4a4a4a] rounded-lg p-3 flex items-center gap-2">
                            <div className="relative">
                                <div
                                // disabled
                                    // onClick={() => setShowCurrencyDropdown(!showCurrencyDropdown)}
                                    className="flex items-center gap-1 text-sm"
                                >
                                    <span>$</span>
                                    <span className="text-xs text-gray-400">USD</span>
                                    {/* <ChevronDown className="w-3 h-3" /> */}
                                </div>
                                {/* {showCurrencyDropdown && (
                                    <motion.div
                                        initial={{ opacity: 0, y: -10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        className="absolute left-0 top-full mt-1 bg-[#5a5a5a] rounded-lg shadow-xl z-10"
                                    >
                                        {currencies.map((c) => (
                                            <button
                                                key={c}
                                                onClick={() => { setCurrency(c); setShowCurrencyDropdown(false); }}
                                                className="block w-full px-4 py-2 text-left text-sm text-white hover:bg-[#6a6a6a]"
                                            >
                                                {c}
                                            </button>
                                        ))}
                                    </motion.div>
                                )} */}
                            </div>
                            <span className="text-white">{usdValue.toFixed(2)}</span>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-between mb-6">
                    <div >
                        <p className="text-xs text-gray-400">
                            Withdrawable balance: <span className="text-[#c9a227]">●</span> {withdrawableBalance.toLocaleString()}
                        </p>
                        <p className="text-xs text-gray-400">
                            Available balance: <span className="text-[#c9a227]">●</span> {coinBalance.toLocaleString()}
                        </p>
                    </div>
                    {insufficientBalance && (
                        <p className="text-xs text-red-500">Insufficient Balance</p>
                    )}
                </div>

                <button
                    onClick={handleConverCoin}
                    disabled={!coinAmount?.trim() || parseFloat(coinAmount) === 0 || insufficientBalance || loading}
                    className={`w-full py-3 rounded-lg font-semibold transition-colors ${parseFloat(coinAmount) > 0 && !insufficientBalance
                            ? 'bg-[#4a4a4a] hover:bg-[#5a5a5a] text-white'
                            : 'bg-[#3a3a3a] text-gray-500 cursor-not-allowed'
                        }`}
                >
                    {loading ? "Converting..." : "Convert"}
                </button>
            </div>
        </ModalWrapper>
    );
}